<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

import './design/bancos/icones-bancos-brasileiros.css';

import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  name: 'App',
  components: {
    
  },
  created() {
    // Flag local para evitar múltiplos redirecionamentos caso várias requisições falhem em paralelo
    let isLoggingOut = false

    axios.interceptors.response.use(
      (response) => {
        return response
      },
      (err) => {
        // Se o backend retornar 401 (Cookie expirado ou inválido)
        if (err.response && err.response.status === 401) {
          
          if (!isLoggingOut) {
            isLoggingOut = true

            // 1. Despacha a ação de logout do Vuex (limpa o state e o localStorage)
            //this.$store.dispatch('authOidc/logout')

            // 2. Redireciona o usuário para a página de login/home
            this.$router.push('/')

            // Pequeno timeout para resetar a flag após o redirecionamento concluir
            setTimeout(() => {
              isLoggingOut = false
            }, 1000)
          }
        }
        return Promise.reject(err)
      }
    )
  }
  // async created() {

  //   axios.interceptors.response.use( (response) =>{
  //     _logout = false
  //   return response
  //   },(err)=>{
  //     //console.log("aqui",err.response)
  //     if (err.response && err.response.status == 401){
  //       this.$router.push('/')
  //     if(!_logout)
  //       //this.$store.dispatch('logout')
  //       _logout = true
  //     }
  //     return Promise.reject(err)
  //   })
  // }
}
</script>

<style lang="scss">


@use 'design/colors.scss' as *;
@use 'design/index.scss' as *;

@font-face {
  font-family: 'Berlin Sans FB Local';
  src:  url('design/fonts/BerlinSansFBBold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}



.month-picker__month.selected{
  background-color: $color-success !important;
  box-shadow: inset 0 0 3px $color-success, 0px 2px 5px rgb(85 176 242 / 20%) !important;
}
.month-picker__container{
  width: 372px !important;
}
</style>
